import { GET_TRAINING_RECORDS_API } from "../../constants/api";
import axios from "../fetch/fetch";

export const getTrainingRecordAPI = async (): Promise<any[]> => {
    const response = await axios.get(GET_TRAINING_RECORDS_API);
    return response.data;
};

export const getTrainingRecordByPeriodAPI = async (year: number, quarter: number): Promise<any[]> => {
    const response = await axios.get(`${GET_TRAINING_RECORDS_API}/${year}/${quarter}`);
    return response.data;
};
